export const belongsToEmployee =
  (id: number) =>
  ({ employeeId }: { employeeId: number }) =>
    employeeId === id;
